<template>
  <div class="text-center">
    <v-dialog v-model="showModal" attach="body" content-class="v-dialog--custom">
      <div class="card h-100 border-0">
        <div class="card-body px-0 pt-0">
          <div class="col color-palette-4 font-weight-bold py-1">
            <span @click="closeModal" class="mr-4" style="cursor: pointer">X</span>
          </div>
          <!--                <img class="d-sm-none" style="cursor: pointer;" @click="irARuta" src="/assets/images/modal/modal-mobile.webp" alt="img-modal-home">
                <img class="d-none d-sm-block" style="cursor: pointer;" @click="irARuta" src="/assets/images/modal/modal-web.webp" alt="img-modal-home">-->
          <picture>
            <source srcset="/assets/images/modal/modal-1300.webp" media="(min-width: 1300px)" />
            <source srcset="/assets/images/modal/modal-1000.webp" media="(min-width: 1000px)" />
            <source srcset="/assets/images/modal/modal-700.webp" media="(min-width: 700px)" />
            <source srcset="/assets/images/modal/modal-400.webp" media="(min-width: 400px)" />
            <img
              style="cursor: pointer"
              @click="irARuta"
              src="/assets/images/modal/modal-mobile.webp"
              alt="img-modal-home"
            />
          </picture>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: 'ModalHome',
    props: {},
    data: () => ({
      showModal: window.sessionStorage.getItem('open_modal_expo_vivienda') ? false : true,
    }),
    mounted() {
      window.sessionStorage.setItem('open_modal_expo_vivienda', 1);
    },
    methods: {
      closeModal() {
        this.showModal = false;
      },
      irARuta() {
        window.location.href = 'contactos-expo-vivienda';
      },
    },

    computed: {},
    watch: {},
    validations: {},
  };
</script>

<style scoped>
  .letter-small {
    font-size: 0.8rem !important;
  }

  input {
    height: 2rem !important;
    border-radius: 9px !important;
  }

  @media (max-width: 639px) {
  }
</style>
